<template>
    <Tree :data="tree" ref="orgTree" :render="render"></Tree>
</template>
<script>
import { listToTree } from "_u/helper";
import { orgList } from "@/api/sys-org";

export default {
    inject: {
        $modal: { default: null },
    },

    data() {
        return {
            list: [],
            defaultIds: {},
        };
    },

    computed: {
        tree() {
            return listToTree(this.list, { id: "id", pId: "pid", copy: false });
        },
        spanMargin() {
            return {
                margin: "0 4px",
            };
        },
    },

    methods: {
        render(h, { data }) {
            if (data.orgLevel == 4) {
                return (
                    <Checkbox
                        value={data.check}
                        onInput={(val) => (data.check = val)}
                    >
                        <span style={this.spanMargin}>{data.name}</span>
                    </Checkbox>
                );
            } else {
                return <span style={this.spanMargin}>{data.name}</span>;
            }
        },
        setTreeData(org) {
            org.data.list.forEach((el) => {
                el.check = this.defaultIds[el.id] == true; // 默认勾选
                el.expand = true;
            });

            this.list = org.data.list;
        },
    },

    created() {
        this.$modal.$on("lookup-open", (data) => {
            this.defaultIds = {};
            data.forEach((v) => (this.defaultIds[v.value] = true));

            // 打开选择框
            this.$modal.beforeEnter((next) => {
                let body = {
                    page: 1,
                    pageSize: 999,
                };
                orgList(body).then((res) => {
                    this.setTreeData(res);
                    next();
                });
            });

            // 关闭选择框
            this.$modal.onBtnClick("confirm", (next, options) => {
                this.$modal.$emit(
                    "lookup-close",
                    this.list.filter((v) => v.check)
                );
                next();
            });
        });
    },
};
</script>